'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

interface ButtonIconProps {
  src: string;
  alt: string;
  height?: number;
  width?: number;
  className?: string;
}

export function ButtonIcon({ src, alt, height = 20, width = 20, className }: ButtonIconProps) {
  return <Image src={src} alt={alt} height={height} width={width} className={className} />;
}
